export const relationshipLabels = {
  spouse: 'Spouse',
  child: 'Child, stepchild, adopted child',
};

export const genderLabels = {
  F: 'Female',
  M: 'Male',
  NA: 'Prefer not to answer',
};
